import React, {createContext, useContext, useEffect, useState} from 'react';

import fetcher from "../fetcher";
import {useFetchHook} from "../hooks/useFetchHook";
import useDidMountEffect from "../hooks/useDidMountEffect";
import {toast} from "react-toastify";

export const DefaultQuoteSettingsContext = createContext(undefined)

export const DefaultQuoteSettingsProvider = ( { children } ) => {
    const [fetchQuoteSettingsResponse, fetchQuoteSettings] = useFetchHook(fetcher.getDefaultQuoteSettings)
    const [updateQuoteSettingsResponse, updateQuoteSettings] = useFetchHook(fetcher.updateDefaultQuoteSettings)

    const [quoteSettings, setQuoteSettings] = useState(null)

    const setSettingsStateWithUpdate = (newState, shouldUpdate) => {
        setQuoteSettings({
            ...quoteSettings,
            ...newState,
            _updateInBackend: shouldUpdate
        })
    }

    // Quote Settings
    useEffect(function fetchQuoteSettingsFromBE(){
        fetchQuoteSettings()
    }, [])

    useEffect(function setFetchedQuoteSettings(){
        if (fetchQuoteSettingsResponse?.data?.data && !fetchQuoteSettingsResponse.loading && !fetchQuoteSettingsResponse.error) {
            setSettingsStateWithUpdate(fetchQuoteSettingsResponse?.data?.data, false)
        }
    }, [fetchQuoteSettingsResponse])

    useEffect(function setUpdatedQuoteSettings(){
        if (updateQuoteSettingsResponse?.data?.data && !updateQuoteSettingsResponse.loading && !updateQuoteSettingsResponse.error) {
            const newSettings = updateQuoteSettingsResponse?.data?.data
            setSettingsStateWithUpdate(newSettings, false)
            toast.success('Successfully saved settings.')
        }
    }, [updateQuoteSettingsResponse])


    useDidMountEffect(function saveSettingsOnQuoteStateChange(){
        if(quoteSettings._updateInBackend === true) {
            updateQuoteSettings(quoteSettings)
        }
    }, [quoteSettings])

    useEffect(function updateQuoteSettingsAcrossTabs(){
        if (quoteSettings) {
            localStorage.setItem('quoteSettings', JSON.stringify({
                ...quoteSettings,
                should_set_state: true,
                _updateInBackend: false,
            }))
        }
    }, [quoteSettings]);

    useEffect(function listenForQuoteSettingsChanges(){
        const handleStorageChange = (e) => {
            if (e.key === 'quoteSettings') {
                const newQuoteSettings = JSON.parse(e.newValue)
                if (newQuoteSettings.should_set_state === true) {
                    delete newQuoteSettings.should_set_state
                    setSettingsStateWithUpdate(newQuoteSettings, false)
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    const value = {
        quoteSettings,
        setSettingsStateWithUpdate,

        updateQuoteSettings,
        updateQuoteSettingsResponse,
    }

    if (!quoteSettings) return null;

    return (
        <DefaultQuoteSettingsContext.Provider value={value}>
            { children }
        </DefaultQuoteSettingsContext.Provider>
    )
}

export const useDefaultQuoteSettingsContext = () => {
    const context = useContext(DefaultQuoteSettingsContext)

    if (context === undefined) {
        throw new Error('useUserContext must be used within UserContext')
    }
    return context
}